import React, { useEffect, useState } from 'react'
import RightSideDetails from "../global/rightSideDetails";
import * as helper from '../global/helper';
import swal from 'sweetalert2';
import Select from 'react-select';
import GetBookingFilter from './GetBookingFilter';
import { deleteCoachBook, getCoachBook, getCoachPaymentTaggingByCoachBookID, postCoachBook } from '../api/coachAPI';
import { getActiveViewUserAll, getGuestAll, getViewUserAll } from '../api/usersAPI';
import AddPayment from '../teeTime/addPayment';

const CaochBooking = (props) => {

    const [isInit,                  setIsInit]                      = useState(true);
    const [rightSideDetails,        setRightSideDetails]            = useState(false);
    const [selectedCoach,           setSelectedCoach]               = useState(null);
    const [selectedSport,           setSelectedSport]               = useState(null);
    const [selectedDate,            setSelectedDate]                = useState(moment().toDate());
    const [bookList,                setBookList]                    = useState([]);
    const [serverTime,              setserverTime]                  = useState(moment().format('YYYY-MM-DD HH:mm:ss'));
    const [bookingTable,            setBookingTable]                = useState(null);
    const [bookSheet,               setBookSheet]                   = useState({});
    const [typeOption,              setTypeOption]                  = useState([{ value:  'User', label: 'Member'}, { value:  'Guest', label: 'Guest'},]);
    const [usersList,               setUsersList]                   = useState([]);
    const [guestList,               setGuestList]                   = useState([]);
    const [bookingUser,             setBookingUser]                 = useState(null);
    const [showAddPayment,          setShowAddPayment]              = useState();
    const [paymentTagging,          setPaymentTagging]              = useState({});
    
    useEffect(() => {
        props.title("Coach Booking", "coach-book");
    }, []);

    useEffect(() => {  
        if(rightSideDetails){
            Config.Core.OpenDrawer()
        }else{
            setBookSheet({})
            setBookingUser(null)
            setPaymentTagging({})
        }
    }, [rightSideDetails]);

    useEffect(() => {
        if (bookSheet && bookSheet.UserID) {
            if (bookSheet.UserType == 'User' && usersList.length > 0) {
                const user = usersList.find(u => u.ID == bookSheet.UserID)
                setBookingUser({...user, UserType: 'User'})
            } else if (bookSheet.UserType == 'Guest' && guestList.length > 0) {
                const guest = guestList.find(u => u.ID == bookSheet.UserID)
                setBookingUser({...guest, UserType: 'Guest'})
            }
        }
    }, [bookSheet, usersList, guestList])

    useEffect(() => {
        if (selectedCoach && selectedDate && selectedSport) {
            fetchCoachBook(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedDate, 'DD-MM-YYYY').format('dddd'), selectedCoach.ID, selectedSport.SportID)
        }
    }, [selectedCoach, selectedDate, selectedSport])

    useEffect(() => {       
        if (!isInit) fillDataTable();
    }, [bookList, serverTime]);

    const updateBookingDetails = (field, value) => { 
        if (field == 'Type') {
            setBookSheet(d => {
                if (field == 'Type' && value == 'User') {
                    return { ...d, UserID : '', [field]: value, UserType: value }
                } else {
                    return { ...d, UserID : '', [field]: value, UserType: value }
                }
            })
        } else {
            setBookSheet((d) => {
                return { ...d, [field]: value, OwnerType: 'Admin' };
            });
        }
    };

    const fetchCoachBook = async (selectedDate, dayName, coachID, sportID) => {
        try {
            const response = await getCoachBook({selectedDate, dayName, coachID, sportID});
            isInit ? setIsInit(false) : $('#tblBookSheet').KTDatatable().destroy(); 
            setBookList(response.booking);
            setserverTime(response.serverTimestamp);
        } catch (error) {
            helper.reuseableSwal('error', 'Error!', error.message)  
        }
    }

    const fetchCoachPaymentTagging = async (id) => {
        try {
            const res = await getCoachPaymentTaggingByCoachBookID(id);
            setPaymentTagging(res)
        } catch (error) {
            helper.reuseableSwal('error', 'Error!', error.message)  
        }
    }

    const fetchUsers = async () => {
        try {
            const users = await getActiveViewUserAll();
            setUsersList(users)
        } catch (error) {
            helper.reuseableSwal('error', 'Error!', error.message)  
        }
    }

    const fetchGuest = async() =>{
        try {
            const guests = await getGuestAll()
            setGuestList(guests);             
        } catch (error) {
            helper.reuseableSwal('error', 'Error!', error.message)  
        }
    };

    function exportSheet(btnType) {
        let fileName = `${moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} - Coach Booking Sheet}`;

        bookingTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: fileName // pass in a new set of properties
        });
        
        if (btnType == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        
        $('.tableexport-caption').addClass('hidden');
    }

    const resetUser = () => {
        setBookSheet(a => ({...a, UserID: ''}))
    }
    // const resetGuest = () => {
    //     setBookSheet(a => ({...a, GuestID: ''}))
    // }

    function fillDataTable() {
        swal.close();

        const dataTable = $('#tblBookSheet').KTDatatable({
            data: {
                saveState: false,
                source   : bookList,
                pageSize : 20
            },
            layout: {
                scroll: true,
                height: $(window).height() - 250,
                footer: false,
            },
            sortable  : true,
            pagination: true,
            search    : { input: $('#generalSearch')},
            columns: [               
                {  field: 'Slot',  title: 'Slot',
                    template: function (row) {
                        return `${row.StartTime} To ${row.EndTime}`
                    },
                    width:250 
                },
                {
                    field: 'Status',
                    title: 'Status',
                    template: function (row) {
                        if (row.Status != null) {
                            return `<span class="badge badge-danger">${row.Status}</span>`
                        } else {
                            return '<span class="badge badge-success"> Available </span>'
                        }
                    },
                    width: 120,
                },
                {
                    field: 'UserName',
                    title: 'Player',
                    width: 120,
                },
                {
                    field: 'CreatedDate',
                    title: 'Time',
                    width: 145,
                    template: function (row) {
                        if (row.CreatedDate == null) {
                            return "";
                        } else {
                            return moment(row.CreatedDate).format('DD-MMM hh:mm:ss.SS A');
                        }
                    }
                },
                {
                    field: '',
                    title: '',
                    width: 60,
                    class: "clickable",
                    template: function (row) {

                        if ((row.Status == "Booked" || row.Status == null)) {
                            return showEditButton(row)
                        } else {
                            return '';
                        }
                    }
                },
            ],
            rows: {
                autoHide: false,
            }
        });

        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblBookSheet .kt-datatable__table').addClass('overflow-x-auto');

        Config.Core.InitPopover();
        Config.Core.GrabAndScroll('.kt-datatable__table');

        // export to excel
        const BookingTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `${moment().format("DD-MM-YYYY")} - Mat Booking Sheet`,
        });
        setBookingTable(BookingTable);
        $('.tableexport-caption').addClass('hidden');
        
        function showEditButton(row) {

            const formattedDate = moment($('#txtDate').val(), 'DD/MM/YYYY').format('DD-MMM-YYYY');

            var optString = '';

            const isEdit = moment(moment(serverTime.ServerDate).format('DD-MMM-YYYY')).isSameOrBefore(formattedDate);

            optString += '<center>'

            if (row.Comment) optString += `<button type="button" class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs mr-1" data-toggle="kt-popover"  data-trigger="hover click" data-placement="left" data-original-title="Comments" data-content="${row.Comment}"><i class="fa fa-info"></i></button>`

            if (isEdit) optString += `<button type="button"  class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-edit"><i class="flaticon2-edit"></i></button>`

            optString += '</center>'

            return optString;
        }

        dataTable.on('click', '.btn-edit', function (ss) {
            const index = $(ss.currentTarget).parents('tr').index();
               
            if (dataTable.dataSet && dataTable.dataSet.length > 0 && dataTable.dataSet[index]) {
                setBookSheet({
                    ...dataTable.dataSet[index],
                    Type        : dataTable.dataSet[index].ID != 0 ? dataTable.dataSet[index].UserType : 'User', 
                    CoachID     : selectedCoach.ID,
                    CoachName   : selectedCoach.Name,
                    SportID     : selectedSport.SportID,
                    SportName   : selectedSport.Name,
                })
                if (dataTable.dataSet[index].ID != 0 && dataTable.dataSet[index].UserType == 'Guest') {
                    fetchCoachPaymentTagging(dataTable.dataSet[index].ID)
                }
                fetchUsers();
                fetchGuest();
                setRightSideDetails(true); 
            } 
        });
    }

    const paymentHandler = (value) => {
        if(value.UserType == 'Guest'){
            // if(paymentTaggingList && paymentTaggingList.length > 0){
                // setPaymentTagging(paymentTaggingList.find((f) => f.UserID == value.UserID && f.TeeTimeBookUserID == value.TeeTimeBookUserID))
            // }else{
            //     setPaymentTagging({})
            // }
            setShowAddPayment(value)
        }
    }

    const deleteUserHandler = () => {
        setBookingUser(null)
    }

    const addBookingGuestHandler = () => {
        if(bookSheet.UserID) {
            const newO = guestList.find((f) => f.ID == bookSheet.UserID)
            setBookingUser({...newO, UserType: 'Guest'})
            paymentHandler({...guestList.find((f) => f.ID == bookSheet.UserID), UserID: bookSheet.UserID, UserType: "Guest"});
        }
    }

    const addBookingUserHandler = () => {
        if(bookSheet.UserID) {
            const newO = usersList.find((f) => f.ID == bookSheet.UserID)
            setBookingUser({...newO, UserType: 'User'})
        }
    }

    const addBookingHandler = async () => {
        const btn = $('#btnSave');
        helper.StartProcessing(btn);
        const bookingDetails = {
            ID:         bookSheet.ID,
            CoachID:    bookSheet.CoachID,
            SportID:    bookSheet.SportID,
            BookDate:   moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
            UserType:   bookSheet.Type,
            UserID:     bookSheet.UserID,
            StartTime:  bookSheet.StartTime,
            EndTime:    bookSheet.EndTime,
            Comment:    bookSheet.Comment
        }

        try {
            await postCoachBook(bookingDetails, paymentTagging)
            closeDrawer();
            fetchCoachBook(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedDate, 'DD-MM-YYYY').format('dddd'), selectedCoach.ID, selectedSport.SportID)
            if (bookingDetails.ID != 0) {
                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Booking updated successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 1500,
                    animation: false,
                    customClass: {
                        popup: 'margin-20',
                    },
                });
            }else{
                swal.fire({
                    icon: 'success',
                    titleText: 'Booking added successfully!',
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        } catch (error) {
            helper.StopProcessing(btn);
            helper.reuseableSwal('error', 'Error!', error.message);
            return;
        }
    }

    const cancelBookingHandler = async () => {
        const btn = $('#btnCancel');
        helper.StartProcessing(btn);

        try {
            await deleteCoachBook(bookSheet.ID)
            helper.StopProcessing(btn);
            fetchCoachBook(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedDate, 'DD-MM-YYYY').format('dddd'), selectedCoach.ID, selectedSport.SportID)
            closeDrawer();
            swal.fire({
                icon: 'success',
                titleText: 'Booking deleted successfully!',
                showConfirmButton: false,
                timer: 1500,
            });
        } catch (error) {
            helper.StopProcessing(btn);
            helper.reuseableSwal('error', 'Error!', error.message);
            return;
        }
    }

    const closeDrawer = () =>{
        Config.Core.CloseDrawer();
        setTimeout(() => {
            setRightSideDetails(false);
        }, 200);
    }

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content" >
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t30 p  adding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className='row'>
                                    <GetBookingFilter
                                        selectedDate={selectedDate}
                                        selectedCoach={selectedCoach}
                                        selectedSport={selectedSport}
                                        setSelectedDate={setSelectedDate}
                                        setSelectedCoach={setSelectedCoach}
                                        setSelectedSport={setSelectedSport}
                                    />
                                    <div className="col-sm-2">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item" 
                                                    onClick={() => exportSheet('xlsx')}
                                                >Excel
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item" 
                                                    onClick={() => exportSheet('csv')}
                                                >Csv 
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="tblBookSheet" className="table table-bordered table-hover custom-datatable"></div>
                            {rightSideDetails && 
                                <RightSideDetails title="Booking Sheet" onCloseDrawer={closeDrawer}>
                                    <div className="kt-portlet">
                                        <div className="kt-portlet__body padding-t30 padding-b0">
                                            <form id="ModalHolder" className="kt-form kt-form--label-right padding-10">
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Date</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <input 
                                                            id="lblDate" 
                                                            disabled="disabled" 
                                                            name="lblDate" 
                                                            type="text" 
                                                            className="form-control"
                                                            value={moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                                        />
                                                    </div>
                                                </div>
                                                <div id="pnlSlot" className="form-group row">
                                                    <label className="col-form-label col-lg-3">Slots</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <input 
                                                            id="lblSlot" 
                                                            disabled="disabled" 
                                                            name="lblSlot" 
                                                            type="text"
                                                            onChange={updateBookingDetails} 
                                                            className="form-control" 
                                                            value={`${bookSheet.StartTime} To ${bookSheet.EndTime}`}
                                                        />
                                                    </div>
                                                </div>
                                                <div id="pnlCoach" className="form-group row">
                                                    <label className="col-form-label col-lg-3">Coach</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <input 
                                                            id="lblCoach" 
                                                            disabled="disabled" 
                                                            name="lblCoach" 
                                                            type="text"
                                                            onChange={updateBookingDetails} 
                                                            className="form-control" 
                                                            value={bookSheet.CoachName}
                                                        />
                                                    </div>
                                                </div>
                                                <div id="pnlSport" className="form-group row">
                                                    <label className="col-form-label col-lg-3">Sport</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <input 
                                                            id="lblSport" 
                                                            disabled="disabled" 
                                                            name="lblSport" 
                                                            type="text"
                                                            onChange={updateBookingDetails} 
                                                            className="form-control" 
                                                            value={bookSheet.SportName}
                                                        />
                                                    </div>
                                                </div>
                                                <div id="pnlType" className="form-group row">
                                                    <label className="col-form-label col-lg-3">Type <span className="red"></span></label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <div>
                                                            <Select 
                                                                id="ddlType" 
                                                                name="ddlType"
                                                                className="multi-custom"
                                                                placeholder="Select Type"
                                                                isDisabled={bookingUser ? true : false}
                                                                value={bookSheet.Type == 'User' ? {value:  'User', label: 'Member'} : {value:  'Guest', label: 'Guest'}}
                                                                onChange={(event) => updateBookingDetails('Type', event.value)}
                                                                options={typeOption}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {bookSheet.Type == "User" ? (
                                                    <div id="UserHolder">
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-3">User</label>
                                                            <div className="col-xl-6 col-lg-8">
                                                                <div className="input-group" >
                                                                    <div style={{width: "60%"}}  >
                                                                        <Select
                                                                            value={(usersList && usersList.length > 0 && bookSheet.UserID) && {label: `${usersList.find(m => m.ID == bookSheet.UserID).Name} (${usersList.find(m => m.ID == bookSheet.UserID).Mobile})`, value: bookSheet.UserID} || ''}
                                                                            onChange={(event) => updateBookingDetails('UserID', event.value)}
                                                                            name="ddlUser"
                                                                            placeholder="Select User"
                                                                            id="ddlUser"
                                                                            isDisabled={bookingUser ? true : false}
                                                                            className="ddlUser"
                                                                            options={usersList.map(c => ({
                                                                                label: `${c.Name} (${c.Mobile})`,
                                                                                value: c.ID
                                                                            }))}
                                                                        />
                                                                    </div>
                                                                    <div className="input-group-append" style={{zIndex: 0}}>
                                                                        <button className="btn btn-secondary kt-select-reset" type="button" onClick={resetUser}><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                                    </div>
                                                                    {!bookingUser && (
                                                                        <button id="btnAddUser" className="btn btn-label-brand margin-l10 margin-r0" type="button"  onClick={addBookingUserHandler}>Add</button>
                                                                    )}
                                                                    {/* <button id="btnNewUser" className="btn btn-label-brand margin-l10" type="button" data-toggle="modal" data-target="#modalUser" onClick={() => setShowAddUser(true)}>New</button> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div id="GuestHolder" >
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-3">Guest</label>
                                                            <div className="col-xl-6 col-lg-8">
                                                                <div className="input-group">
                                                                    <div style={{width: "60%"}}  >
                                                                        <Select
                                                                            value={(guestList && guestList.length > 0 && bookSheet.UserID) && {label: `${guestList.find(m => m.ID == bookSheet.UserID).Name} (${guestList.find(m => m.ID == bookSheet.UserID).Mobile})`, value: bookSheet.UserID}}
                                                                            onChange={(event) => updateBookingDetails('UserID', event.value)}
                                                                            name="ddlGuest"
                                                                            placeholder="Select Guest"
                                                                            id="ddlGuest"
                                                                            isDisabled={bookingUser ? true : false}
                                                                            data-live-search="true"
                                                                            className="ddlGuest"
                                                                            options={guestList.map(c => ({
                                                                                label: `${c.Name} (${c.Mobile})`,
                                                                                value: c.ID
                                                                            }))}
                                                                        />
                                                                    </div>
                                                                    <div className="input-group-append" disabled={bookingUser ? true : false} style={{zIndex: 0}}>
                                                                        <button 
                                                                            
                                                                            className="btn btn-secondary kt-select-reset" type="button" onClick={resetUser}><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                                    </div>
                                                                    {!bookingUser && (
                                                                        <button id="btnAddGuest" className="btn btn-label-brand margin-l10 margin-r0" type="button" onClick={addBookingGuestHandler}>Add</button>
                                                                    )}
                                                                    {/* <button id="btnNewGuest" className="btn btn-label-brand margin-l10" type="button" data-toggle="modal" data-target="#modalGuest"  onClick={() => setShowAddGuest(true)} >New</button> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Comment</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <textarea 
                                                            id="txtComment" 
                                                            name="txtComment" 
                                                            className="form-control" 
                                                            rows="3"
                                                            value={bookSheet.Comment || ''}
                                                            onChange={(event) => updateBookingDetails('Comment', event.target.value)} 
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </form>
                                            <table id="table-user" className="table table-bordered table-hover margin-b30">
                                                <thead className="light-grey-background">
                                                    <tr>
                                                        <th>Players</th>
                                                        <th className="text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                {bookingUser &&
                                                    <tbody>
                                                        <tr>
                                                            <td onClick={() => {paymentHandler(bookingUser)}}>
                                                                <span className={`kt-badge kt-badge--${bookingUser.UserType == "User" ? 'success' : (bookingUser.UserType == "Guest" || bookingUser.UserType == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot`}>
                                                                </span>&nbsp; &nbsp;{bookingUser.Name}{bookingUser.UserType == "Guest" && ` (G) - ${paymentTagging?.TagTo || 'Direct'}`}
                                                            </td>
                                                            <td>
                                                                <center>
                                                                    <button className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r10 btn-user-delete" type="button" onClick={deleteUserHandler} >                  
                                                                        <i className="flaticon2-rubbish-bin-delete-button"></i>             
                                                                    </button>
                                                                </center>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                }
                                                <tfoot></tfoot>
                                            </table>
                                            <div className="row margin-bl5">
                                                <div className="col-sm-12 pl-0">
                                                    <h6 className="margin-0">
                                                        <strong id="lblOwner">
                                                            {(bookingUser) ? 'Booked By ' + (bookSheet.OwnerType == 'Admin' ? 'Admin' : bookingUser.Name) : '' }
                                                        </strong>
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="kt-portlet__foot">
                                            <div className="kt-form__actions">
                                                <div className="row">
                                                    <div className="col-lg-12 text-right">
                                                        <button id="btnSave" type="button" className="btn btn-brand d-inline-block" onClick={addBookingHandler}>{bookSheet.ID ? 'Update Booking' : 'Save Booking' }</button>
                                                        {bookSheet && 
                                                            bookSheet.ID != 0 && <button id="btnCancel" type="button" className="btn btn-warning d-inline-block margin-l10" onClick={cancelBookingHandler}>Cancel Booking</button>
                                                        }
                                                        <button id="btnCloseDrawer" type="button" className="btn btn-secondary margin-l10" onClick={closeDrawer}>Close</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </RightSideDetails>
                            }
                        </div>
                    </div>
                </div>
            </div>
            {(showAddPayment && Object.keys(showAddPayment).length !== 0) && (
                <AddPayment
                    show={showAddPayment}
                    MemberDetails={showAddPayment}
                    onDismissModal={setShowAddPayment} 
                    setPaymentTagging={setPaymentTagging} 
                    paymentTagging={paymentTagging} 
                    MemberList={usersList} 
                />
            )}
        </>
        
    )
}

export default CaochBooking